export const modals = {
  delete: {
    title: "Are you sure?",
    description: "This will delete your asset. You cannot undo this action, do you wish to continue?",
  },
};
